import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import {
  ValoreEconomicoRevisioneFormComponent
} from '../../../form/sez-economica/valore-economico-revisione-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
  selector: 'div [valore-economico-revisione-form-add]',
  templateUrl: '../../../form/sez-economica/valore-economico-revisione-form.component.html',
})

export class ValoreEconomicoAddRevisioneComponent extends ValoreEconomicoRevisioneFormComponent implements OnInit{
  petitumRevisione: PetitumRevisione;
  urlInsert: string;
  sezione: SezioneEconomica;
  fascicolo: FascicoloFull;
  @Input() edit: boolean;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService) {
    super(operationService, campiForm, helpers, modalNotifyService);
  }
  ngOnInit() {
    this.setTitle('Aggiungi revisione valori economici');
    this.isInserimento(true);
  }

  getEdit() {
    return this.edit;
  }

  getPetitumRevisione() {
    return this.petitumRevisione;
  }
  getSezione() {
    return this.sezione;
  }

  getFascicolo() {
    return this.fascicolo;
  }

  getRequest(petitumRevisione: PetitumRevisione) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione && this.sezione.id) {
      idSezione = this.sezione.id;
    }
    // debugger;
    this.operationService.addPetitumRevisione(this.urlInsert, petitumRevisione, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlInsert = urlInsert;
    this.petitumRevisione = petitumRevisione;
    this.recuperoCrediti = recuperoCrediti;
    this.createForm();
    this.populateSelect();
  }

}
